import styled, { css } from 'styled-components';
import { xsRegular } from '../theme/typography';
import { themeColor } from '../theme/colors';
import { HudIcon } from '../Icons/HudIcons';
import { clickableMixin } from '../theme/utils';
export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
`;

export const Label = styled.span`
  ${xsRegular}
  color: ${themeColor('textTertiary')};
`;

export const Button = styled.button`
  display: flex;
  width: 28px;
  height: 28px;
  padding: 6px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  outline: none;

  border: 1px solid ${themeColor('strokeSecondary')};
  background: ${themeColor('backgroundLight')};
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);

  &:hover {
    border: 1px solid ${themeColor('strokePrimary')};
    background: ${themeColor('buttonBackground')};
  }

  &:active {
    border: 1px solid ${themeColor('strokeSecondary')};
    background: ${themeColor('buttonBackgroundHover')};
  }

  &:disabled {
    border: 1px solid ${themeColor('strokeSecondary')};
    background: ${themeColor('backgroundLight')};
  }
  &:not(:disabled) {
    ${clickableMixin}
  }
`;

export const Icon = styled(HudIcon)<{ $left?: boolean; disabled?: boolean }>`
  transform: ${({ $left }) => ($left ? 'rotate(180deg)' : 'rotate(0deg)')};

  ${({ disabled }) =>
    disabled
      ? css`
          color: ${themeColor('textTertiary')};
        `
      : css`
          color: ${themeColor('textPrimary')};
        `};
`;
